function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { config } from "../../../Shared/config";
import { getCookie, setCookie } from "../../../Shared/utils/cookies";
import { acceptCookies, denyCookies, getCookieStatus } from "../../../Shared/utils/datalayer.mapping";
import { Link } from "./library/link";
import { trackCookiesAccepted, trackCookiesDenied } from "./library/tracking";
// FramedCookiebar() does not render <Cookiebar/> when the website is being displayed
// in an iframe. This is because the website is iframed in public librarian computers
// who do not support cookies. Origin of iframe: https://cmsv2.beesmart.nl/.
export const FramedCookiebar = (props)=>window.self === window.top ? /*#__PURE__*/ _jsx(Cookiebar, {
        ...props
    }) : null;
export class Cookiebar extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.status !== nextProps.status || this.state.expanded !== nextState.expanded || this.state.videoCookiesAccepted !== nextState.videoCookiesAccepted;
    }
    render() {
        let p = this.props;
        const { expanded } = this.state;
        const items = [
            {
                kind: 'functional',
                label: 'Functioneel. Deze cookies zijn nodig om de website goed te laten werken.',
                disabled: true,
                isAccepted: true
            },
            {
                kind: 'analytical',
                label: 'Analytisch. Met deze cookies analyseren we het gebruik van de website. We slaan geen persoonsgegevens op.',
                disabled: true,
                isAccepted: true
            },
            {
                kind: 'video',
                label: "Video's. Met deze cookies spelen we video's af op de website. (optioneel)",
                disabled: false,
                toggleCookie: this.toggleVideoCookies,
                isAccepted: this.state.videoCookiesAccepted
            }
        ];
        return p.status != "accepted" && p.status != "denied" ? /*#__PURE__*/ _jsx("div", {
            className: "cookiebar",
            role: "alert",
            "aria-label": "Cookiebar",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "cookiebar__inner container--mg align--center",
                ref: this.cookiebar,
                children: [
                    /*#__PURE__*/ _jsxs("p", {
                        className: "text--s text--styled",
                        children: [
                            "Om onze website zo goed mogelijk te gebruiken, is het nodig dat je onze cookies accepteert. Dat klinkt makkelijk en dat is het ook. Door op accepteren te klikken, geef je ons toestemming om cookies te plaatsen. Wil je dit liever niet? Dan kun je ervoor kiezen om alleen akkoord te gaan met minimale cookies. Hiermee analyseren we onze website en daarbij slaan we geen persoonsgegevens op. Lees voor meer informatie onze",
                            " ",
                            /*#__PURE__*/ _jsx(Link, {
                                url: config().privacyStatementUrl,
                                className: "cookiebar__link",
                                children: "privacyverklaring"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "cookiebar__actions",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("button", {
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            acceptCookies();
                                            trackCookiesAccepted();
                                            this.setState({
                                                videoCookiesAccepted: true
                                            });
                                            p.onChange("accepted");
                                            window.location.reload();
                                        },
                                        className: "button button--primary",
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "button__label",
                                            children: "Cookies accepteren"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("button", {
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            denyCookies();
                                            trackCookiesDenied();
                                            p.onChange("denied");
                                            window.location.reload();
                                        },
                                        className: "button button--secondary",
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "button__label",
                                            children: "Ik wil alleen minimale cookies"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                onClick: (e)=>{
                                    e.preventDefault();
                                    this.toggleExpand();
                                },
                                className: "button button--secondary",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "button__label",
                                    children: expanded ? "Minder keuzes" : "Meer keuzes"
                                })
                            })
                        ]
                    }),
                    expanded && /*#__PURE__*/ _jsxs("div", {
                        className: "cookiebar__extended",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text--s text--styled",
                                children: "Hier kun je gedetailleerde cookie-instellingen aanpassen. Kies welke soorten cookies je wilt accepteren:"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "cookiebar__extended--options",
                                children: items.map((item, index)=>/*#__PURE__*/ _jsxs("div", {
                                        className: "form__checkbox",
                                        children: [
                                            /*#__PURE__*/ _jsx("input", {
                                                id: `${item.kind}_${index.toString()}`,
                                                className: 'form__input--checkbox',
                                                type: "checkbox",
                                                checked: item.isAccepted,
                                                name: item.kind,
                                                value: item.label,
                                                disabled: item.disabled,
                                                onChange: item.toggleCookie ? item.toggleCookie : undefined,
                                                "aria-describedby": 'label-id'
                                            }),
                                            /*#__PURE__*/ _jsx("label", {
                                                id: `${item.kind}_label-id`,
                                                className: 'form__label--checkbox',
                                                htmlFor: `${item.kind}_${index.toString()}`,
                                                children: item.label
                                            })
                                        ]
                                    }, `tag__${index}`))
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                onClick: this.savePreferences,
                                className: "button button--primary",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "button__label",
                                    children: "Instellingen opslaan"
                                })
                            })
                        ]
                    })
                ]
            })
        }) : null;
    }
    constructor(props){
        super(props), _define_property(this, "cookiebar", /*#__PURE__*/ React.createRef()), _define_property(this, "toggleExpand", ()=>{
            this.setState((prevState)=>({
                    expanded: !prevState.expanded
                }));
        }), _define_property(this, "toggleVideoCookies", ()=>{
            const newValue = !this.state.videoCookiesAccepted;
            setCookie("video-cookies", newValue ? "yes" : "no", 365);
            this.setState({
                videoCookiesAccepted: newValue
            });
        }), _define_property(this, "savePreferences", ()=>{
            if (this.state.videoCookiesAccepted) {
                acceptCookies();
            } else {
                denyCookies();
            }
            this.props.onChange("accepted");
        });
        this.state = {
            expanded: false,
            videoCookiesAccepted: getCookie("video-cookies") === "yes"
        };
    }
}
export const ChangeCookiesLink = (p)=>/*#__PURE__*/ _jsx("a", {
        className: "footer__link",
        href: "",
        onClick: (e)=>{
            e.preventDefault();
            p.onChange("changing");
        },
        children: "Cookie-instellingen"
    });
export const CookieSensitiveContentWrapper = (props)=>getCookieStatus() == 'accepted' ? /*#__PURE__*/ _jsx(_Fragment, {
        children: props.children
    }) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "cookiebar-placeholder",
                children: props.placeholder ? props.placeholder : /*#__PURE__*/ _jsxs("p", {
                    className: "cookiebar-placeholder__text text--styled",
                    children: [
                        "Je kunt deze inhoud alleen bekijken als je de cookies accepteert. ",
                        /*#__PURE__*/ _jsx("a", {
                            href: "/cookies",
                            children: "Meer informatie over cookies"
                        }),
                        "."
                    ]
                })
            }),
            ChangeCookiesLink({
                onChange: props.onChange
            })
        ]
    });
{}